<template>
    <span><InputNumber  size="small" v-model="radius" :min="min" :max="max" @on-change="changed"></InputNumber>
    %</span>
</template>

<script>
export default {
    name: 'percentAttr',
    props: {
        value: {
            type: Number
        },
        min: {
            type: Number,
            default: -Infinity
        },
        max: {
            type: Number,
            default: Infinity
        }
    },
    data() {
        return {
            radius: 0
        }
    },
    watch: {
        value:{
            handler(v){
                if (v < this.min) {
                    this.radius = this.min;
                } else if (v > this.max) {
                    this.radius = this.max;
                } else {
                    this.radius = v;
                }
            },
            immediate:true
        },
    },
    methods: {
        changed(v){
            if (v < this.min) {
                this.radius = this.min;

            } else if (v > this.max) {
                this.radius = this.max;
            }
            this.$emit("input", this.radius);
            this.$emit("save");
        }
    },
}
</script>

<style scoped lang="less">
@import url('~@/runtime-components/assets/common.css');
</style>